import _ from 'lodash/fp'
import { useQuery } from 'react-apollo'
import gql from 'graphql-tag'

import { RETURN_PATH } from '../../../config'

const externalIdQuery = gql`
query {
  me {
    externalId
  }
}
`
const buildShareData = ({ data }) => {
  if (!data) {
    return {}
  }

  const externalId = _.get('me.externalId', data)
  const title = 'Spil med i GLFR Open sammen med mig!'
  const text = `Hey

Jeg deltager i GLFR Open, hvor man kan vinde en masse fede præmier - blandt andet rejser for 60.000,- fra Bravo Tours.
Hvis du tilmelder dig via mit link, får vi begge ekstra lodder i konkurrencen:

`
  const url = `${RETURN_PATH}/open/?rf=${externalId}`
  return {
    // Common
    title,
    url,
    // Native share
    text,
    // Social
    hashtag: '#GLFROPEN',
    quote: title,
    // Email
    subject: title,
    body: text
  }
}

const useShareData = () => (
  buildShareData(useQuery(externalIdQuery))
)

export default useShareData
